import { Card, Space } from 'antd';
import { Link } from 'react-router-dom';

import { Error403Unauthorized } from '@app/components';
import { useNewUserAccessRights } from '@app/hooks';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import { generateKey } from '@app/utils';

import { menu } from '@pages/ControlPanel/data';

export const ControlPanel = () => {
  const { userAccessRights } = useNewUserAccessRights();

  if (!userAccessRights.IsSuperAdmin) {
    return <Error403Unauthorized />;
  }

  return (
    <div>
      <Space size="large" align="start" wrap>
        {menu.map(({ groupName, items, groupTestId }) => {
          return (
            <Card
              key={generateKey('ControlPanel', 'group', groupName)}
              type="inner"
              title={generateSpanWithDataTestId(groupName, groupTestId)}
              style={{ width: 264 }}
            >
              <Space direction="vertical">
                {items.map(({ name, path, itemDataTestId }) => {
                  return (
                    <Link
                      key={generateKey('ControlPanel', 'groupItem', name)}
                      to={path}
                      data-testid={itemDataTestId}
                    >
                      {name}
                    </Link>
                  );
                })}
              </Space>
            </Card>
          );
        })}
      </Space>
    </div>
  );
};
